let ResidentsOfAIONCharacters = [
    {
        characterName: 'Synarchy',
        gender: '♂',
        height: 179,
        position: "초신성! 데미우르고스 얄다바오트 시나르키아 루키페로스",
        description: ["해저의 기상 연구원. 동시에 기상의 신 호라이의 조수. ",
            "날 때부터 저주받은 몸이라 인간도 요괴도 신도 아니다. 그래서 어느 사회에도 소속되지 못하고 있으며, ",
            "이상한 신이나 이해 불능의 존재들한테 곧잘 사랑받는다. ",
            "좋아하는 것은 연어초밥, 드라이브. 미래에는 다 때려치우고 택시기사나 할까 싶다. ",
            "어느날 이유도 모르게 사라진 호라이를 찾으러 아가르타와 함께 떠나기로 했다."
        ],
        imageOffset: {x: -10, y: -70}
    },
    {
        characterName: 'Horai',
        gender: '♀',
        height: 158,
        position: "기후의 신 현전봉래 호라이 아욱소",
        description: ["본래 여름의 신이었으나 기후변화 탓에 사실상 기후 전체를 총괄하게 됐다. ",
            "인간 출신으로, 공채에 합격해 신이 된 케이스. 이때문에 곱지 못한 시선도 곧잘 받았다. ",
            "삶의 낙이라면 저녁에 조수 시나키와 함께 맥주 한잔 하며 날씨 얘기나 하는 것. ",
            "하지만 신이라는 작자가 그걸로 충분한 걸까, 매번 고민하고 있다. ",
            "어느날 실종되었다. 덕분에 곳곳의 날씨가 난장판이다."
        ],
        imageOffset: {x: 15, y: -70}
    },
    {
        characterName: 'Odradek',
        gender: '?',
        height: 160,
        position: "비신. 秘神. 非神.",
        description: ["인간도 아니고 신도 아니다. 요괴도 아니고 무생물도 아니다. ",
            "모든 곳에 있지만 아무 곳에도 없고, 모든 것을 알지만 아무것도 모른다. ",
            "의미의 틈새에서 자라는 존재. 어쩌면 필요없는 무언가. ",
            "시나르키아가 오드라덱이라 부르고 있지만, 딱히 이름은 아니다. ",
            "최근 인간 흉내를 잘 낼 수 있게 되었다."
        ],
        imageOffset: {x: 5, y: -90}
    },
    {
        characterName: 'Ennmaten',
        gender: '♂',
        height: 189,
        position: "염마천 백사야 권현",
        description: ["작은 인간사회의 수호신...이었다. 현재는 실종 상태. ",
            "세상의 운행에 관여하는 천상신과는 달리, 지상에서 인간을 돌보던 지상신의 일부. ",
            "진짜 이름도, 신격도 잊혀져 남아있지 않다. 아가르타만이 그가 존재했다는 증거. ",
            "아가르타의 기억 속에서는 따듯하고 상냥한 주인. 동물을 좋아했던 것 같다. ",
            "본부에서는 사망 또는 소멸으로 추정하고 있으나 아가르타는 부정 중."
        ],
        imageOffset: {x: 10, y: -40}
    },
    {
        characterName: 'Agartha',
        gender: '♂',
        height: 175,
        position: "츠쿠모가미 수문장 선이사 다길니천 아(스)가르타",
        description: ["어느 지상신이 쓰던 제구가 버려진 채 영혼을 머금어, 요괴로 되살아난 존재. ",
            "쓰레기장(천공)에서 살다가, 사라진 주인을 찾기로 결심하여 지상으로 내려온다. ",
            "그때 만난 인간 시나키에게 아가르타라는 이름을 받게 되었다. 지금도 협력하며 지낸다. ",
            "아직 인간 사회에 적응을 못해서 수많은 규율과 불문율을 부수고 다닌다. ",
            "시나키에게 매번 잔소리 듣지만, 별로 고칠 생각은 없어 보인다. "
        ],
        imageOffset: {x: 25, y: -50}
    },
];

export default ResidentsOfAIONCharacters;